import React from "react";
import { Space, Descriptions } from "antd";

import { W1, W2 } from "@components/Constants";
import { hasAccess } from "@components/Authorization";
import { EditableGroup } from "@components/Button";

import getLinkTemplatesItems from "./helpers/getLinkTemplatesItems";

const MAX_WIDTH = 690;

const LABEL_LINK_TEMPLATES = "Custom Links";

type LinkTemplates = {
  documentsUrl?: string;
  investmentSignThankYouUrl?: string;
  investmentSignUrl?: string;
  investmentUrl?: string;
  portalUrl?: string;
  signInUrl?: string;
  softCommitmentUrl?: string;
};

type Organization = {
  linkTemplates?: LinkTemplates;
};

type Props = {
  organization: Organization;
  openUpdateLinkTemplates: () => void;
  description?: string;
};

const OrganizationIntegration = ({
  organization,
  openUpdateLinkTemplates,
  description,
}: Props): JSX.Element => {
  const linkTemplatesItems = getLinkTemplatesItems(organization);
  const isEditable = hasAccess(['org-write']);

  return (
    <Space direction="vertical" size={W1} style={{ marginBottom: W2 }}>
      <EditableGroup
        title={LABEL_LINK_TEMPLATES}
        description={description}
        style={{ width: "100%" }}
        onClick={openUpdateLinkTemplates}
        isEditable={isEditable}
      >
        <Descriptions
          bordered
          size="small"
          style={{ minWidth: MAX_WIDTH }}
          column={1}
          labelStyle={{ width: 180, whiteSpace: "nowrap" }}
        >
          {linkTemplatesItems}
        </Descriptions>
      </EditableGroup>
    </Space>
  );
};

export default OrganizationIntegration;
